import HTMLFlipBook from 'react-pageflip';
import { Document, Page, pdfjs } from 'react-pdf';
import { useState, useEffect, useRef, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ArrowLeftCircle, ArrowRightCircle } from 'react-bootstrap-icons'

// Replace the unpkg line with this:
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

//react-zoom-pan-pinch implement this for zooming

const Publication = () => {
  const [numPages, setNumPages] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [pagesReady, setPagesReady] = useState(0)
  const [isOpened, setIsOpened] = useState(false);
  const [focusClass, setFocusClass] = useState('focus-center');
  const [isMobile, setIsMobile] = useState(window.innerWidth > 768);
  const book = useRef();
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth > 600 ? 550 : 300,
    height: window.innerWidth > 600 ? 733 : 400,
  });
  const lastPageIndex = useRef(0); // Track the previous position

  const isPortrait = window.innerHeight > window.innerWidth;

  const minWidth = isMobile
    ? (isPortrait ? 300 : 600)    // smaller in portrait, wider in landscape
    : (isPortrait ? 768 : 1024);

  const minHeight = isMobile
    ? (isPortrait ? 400 : 375)    // taller in portrait, shorter in landscape
    : (isPortrait ? 1200 : 768);

  const maxWidth = 2000;
  const maxHeight = 2000;

  useEffect(() => {
    const handleResize = () => {
      const isMob = window.innerWidth < 768;
      const isTab = window.innerWidth < 1024;
      const isPortrait = window.innerHeight > window.innerWidth;
      // setIsMobile(isMobile ? isMob : isTab);
      setIsMobile(isMob);

      // if (!isMob && focusClass === 'focus-center') {
      //   setFocusClass('focus-center');
      // }

      // Calculate dimensions based on screen width
      if (window.innerWidth < 390) {
        setDimensions({ width: 375, height: 1500 }); // mobile smaller screens
      } else if (window.innerWidth < 600) {
        setDimensions({ width: 405, height: 2500 }); // mobile bigger screens
      } else if (window.innerWidth < 768) {
        setDimensions({ width: 768, height: 1024 });
      } else if (window.innerWidth < 1024) {
        setDimensions({ width: 500, height: 800 }); // larger Tablets
      } else {
        setDimensions({ width: 1024, height: 1400 }); // Desktop
      }

      // if (isPortrait) {
      //   if (window.innerWidth < 390) {
      //     setDimensions({ width: 375, height: 1500 }); // small portrait phones
      //   } else if (window.innerWidth < 600) {
      //     setDimensions({ width: 405, height: 2500 }); // larger phones portrait
      //   } else if (window.innerWidth < 768) {
      //     setDimensions({ width: 768, height: 1024 }); // small tablets portrait
      //   } else if (window.innerWidth < 1024) {
      //     setDimensions({ width: 768, height: 1024 }); // large tablets portrait (match iPad)
      //   } else {
      //     setDimensions({ width: 1024, height: 1400 }); // desktop portrait
      //   }
      // } else {
      //   // Landscape view (wider widths, shorter heights)
      //   if (window.innerWidth < 600) {
      //     setDimensions({ width: 600, height: 375 }); // small phones landscape
      //   } else if (window.innerWidth < 768) {
      //     setDimensions({ width: 768, height: 600 }); // tablets landscape
      //   } else if (window.innerWidth < 1024) {
      //     setDimensions({ width: 1024, height: 768 }); // large tablets landscape
      //   } else {
      //     setDimensions({ width: 1400, height: 1024 }); // desktop landscape
      //   }
      // }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [focusClass]);

  // useEffect(() => {
  //   const handleResize = () => {
  //     const isMob = window.innerWidth < 768;
  //     setIsMobile(isMob);

  //     // 1. Get the height of your header and footer
  //     // Replace '.header' and '.footer' with your actual class names or IDs
  //     const headerHeight = document.querySelector('.navigation-bar')?.offsetHeight || 80;
  //     const footerHeight = document.querySelector('.footer')?.offsetHeight || 60;

  //     // 2. Calculate "Leftover" height (with a small buffer)
  //     const availableHeight = window.innerHeight - headerHeight - footerHeight - 40;

  //     // 3. Calculate Width based on the Aspect Ratio of your PDF
  //     // Standard Newsletter (A4) ratio is roughly 0.70
  //     const aspectRatio = 0.70; 
  //     let w = availableHeight * aspectRatio;

  //     // 4. Mobile Safety Check
  //     // Ensure the calculated width doesn't exceed the phone screen width
  //     if (isMob && w > window.innerWidth * 0.95) {
  //       w = window.innerWidth * 0.95;
  //       // If we hit the width limit, we must shrink the height to match
  //       var h = w / aspectRatio;
  //     } else {
  //       var h = availableHeight;
  //     }

  //     setDimensions({ 
  //       width: isMob ? w : w * 2, // Double width for desktop spread
  //       height: h 
  //     });
  //   };

  //   window.addEventListener('resize', handleResize);
  //   handleResize(); // Initialize on mount
  //   return () => window.removeEventListener('resize', handleResize);
  // }, [focusClass]);

  // useEffect(() => {
  // const handleResize = () => {
  //   const isMob = window.innerWidth < 768;
  //   const w = isMob 
  //     ? Math.min(window.innerWidth * 0.9, 450) 
  //     : Math.min(window.innerWidth * 0.8, 1000);
    
  //   // Maintain a 3:4 aspect ratio per page
  //   // Desktop shows 2 pages, so we divide width by 2 for the ratio
  //   const h = isMob ? w * 1.4 : (w / 2) * 1.4;

  //   setIsMobile(isMob);
  //   setDimensions({ width: w, height: h });

  //   if (isMob && focusClass === 'focus-center') {
  //     setFocusClass('focus-center'); 
  //   }
  // };

  //   window.addEventListener('resize', handleResize);
  //   handleResize(); // Initial call
  //   return () => window.removeEventListener('resize', handleResize);
  // }, [focusClass]);

  // useEffect(() => {
  //   const handleResize = () => {
  //     const mobileCheck = window.innerWidth < 768;
  //     setIsMobile(mobileCheck);
  //     // If we just switched to mobile, ensure we have a focus class set
  //     if (mobileCheck && focusClass === 'focus-center') {
  //       setFocusClass('focus-center'); 
  //     }
  //   };

  //   handleResize();
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, [focusClass]);

  // This runs once the PDF is successfully loaded
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onPageRenderSuccess = () => {
    setPagesReady((prev) => {
      const newCount = prev + 1;
      // Use the updated value to trigger completion
      if (newCount >= 1 || pagesReady >= 1) { 
        setIsLoading(false);
      }
      return newCount;
    });
  };

  const handleLeftClick = () => {
    console.log("handle left click fired");
    if (focusClass === 'focus-center') {
      return;
    }

    book.current.pageFlip().flipPrev();

    if (focusClass === 'focus-left') {
      // Just trigger the flip. onFlip will catch the index change 
      // and update the focusClass automatically.
      book.current.pageFlip().flipPrev();
    } else {
      // If we're on the right, just shift focus to the left side of the current spread
      setFocusClass('focus-left');
    }
    // comment out to test mobile view, tweak later
  }

  const handleRightClick = () => {
    console.log("handle right click fired");
    // book.current.pageFlip().flipNext();
    if (focusClass === 'focus-left' || focusClass === 'focus-center') {
      // Just trigger the flip. onFlip will catch the index change 
      // and update the focusClass automatically.
      book.current.pageFlip().flipNext();
    } 
    else {
      // If we're on the right, just shift focus to the left side of the current spread
      setFocusClass('focus-right'); 
      //TODO comment out to prevent panning to the right
    } 
  }


  const handlePageClick = (index) => {
    // if (!isMobile) return;
    // // Indexing logic: 
    // // Even index (0, 2, 4) = Right-hand side page
    // // Odd index (1, 3, 5) = Left-hand side page
    // if(index === 0) {
    //  setFocusClass('focus-center');
    // } // fix bug when on cover it can focus left
    // if (index % 2 === 1) {
    //   console.log("1");
    //   console.log("setting focus-right");
    //   setFocusClass('focus-right');
    // } else if (index % 2 !== 1) {
    //   console.log("2");
    //   setFocusClass('focus-left');
    // } else {
    //   console.log("3");
    //   setFocusClass('focus-left');
    // }
    if (isMobile) return;

    // 1. Run your existing focus/index logic here...
    
    // 2. MANUALLY tell the book to flip
    if (!isMobile && book.current) {
      // If user clicks the right-hand page, flip forward. 
      // If left-hand page, flip back.
      if (index % 2 === 0) {
        book.current.pageFlip().flipNext();
      } else {
        book.current.pageFlip().flipPrev();
      }
    }
  };

  const onFlip = useCallback((e) => {
    const pageIndex = e.data;
    const isGoingBackwards = pageIndex < lastPageIndex.current;
    
    setIsOpened(pageIndex > 0);

    if (!isMobile && pageIndex === 0) {
      setFocusClass('focus-center');
    } 
    else if (!isMobile && isGoingBackwards) {
      // If we moved backwards, we want to look at the right page of the new spread
      setFocusClass('focus-right');
      // TODO added !isMobile to prevent panning to the left
    } else {
      // If we moved forwards, we usually want to look at the left page of the new spread
      setFocusClass('focus-left');
    }

    lastPageIndex.current = pageIndex; // Update the ref for the next flip
  }, [!isMobile]);

  // const showButtons = () => {
  //   const buttons = document.querySelectorAll('.arrow-left-circle-button, .arrow-right-circle-button');
  //   let timeout;

  //   buttons.forEach(btn => btn.style.opacity = '1');
  //   clearTimeout(timeout);
  //   timeout = setTimeout(() => {
  //     buttons.forEach(btn => btn.style.opacity = '0');
  //   }, 3000);
  // }
  const buttons = document.querySelectorAll('.arrow-left-circle-button, .arrow-right-circle-button');
  let timer;
  let lastRun = 0;
  const handleInteraction = () => {
    const now = Date.now();
    // Show buttons

    if (now - lastRun < 100) return;
    lastRun = now;

    buttons.forEach(btn => {
      btn.style.opacity = '1'; 
      btn.style.pointerEvents = 'auto';
      }
    );
    
    // Reset the "hiding" clock
    clearTimeout(timer);
    
    // Hide after 2 seconds of inactivity
    timer = setTimeout(() => {
      buttons.forEach(btn => {btn.style.opacity = '0'; btn.style.pointerEvents = 'none';});
    }, 2000);
  };

  // Desktop: Mouse movement
  window.addEventListener('mousemove', handleInteraction);

  // Mobile: Screen taps
  window.addEventListener('touchstart', handleInteraction);

  // Interaction: Button clicks (prevents buttons hiding while you are clicking them)
  buttons.forEach(btn => btn.addEventListener('click', handleInteraction));
  
  // This triggers every time the user taps anywhere on the screen
  // document.addEventListener('pointerdown', showButtons);
  // const rightBtn = document.querySelector('.arrow-right-circle-button');
  // rightBtn.addEventListener('click', showButtons);

  // css recommended for mobile
  // .tap-zone {
  //   position: absolute;
  //   top: 0;
  //   bottom: 0;
  //   width: 25%; /* Responsive width */
  //   z-index: 50; /* Below the buttons, above the text */
  // }
  // .left-zone { left: 0; }
  // .right-zone { right: 0; }

  return (
    <div className='publication-main-content'>
      <div className='publication-container'>
        <div className='publication-row'>
          <div className='the-clarion-publication-title'>
            <h1>The Clarion: The JCI Lucena Digest - 1st Issue</h1>
          </div>
          <div className='publication-col'>
            {/* <div className='publication-issues-sidebar'>
              <h1>Issues</h1>
            </div> */}
            {isLoading && (
              <div className="absolute-loader" style={{
                position: 'absolute', zIndex: 10, width: '100%', height: '700px', 
                background: '#ebebeb', display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <div className='loader-div'>
                  <div className='loader'></div>
                  <div>Rendering Publication...</div>
                </div>
              </div>
            )}
            <div className='publication-content-div'>
              {/* {isMobile && (
                <div>
                  <ArrowLeftCircle onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleLeftClick()}} className='arrow-left-circle-button' size={30} color='black'/>
                  <ArrowRightCircle  onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleRightClick()}} className='arrow-right-circle-button' size={30} color='black'/>
                </div>
              )} */}
              <div className={`pdf-document-div ${isOpened ? 'book-opened' : 'book-closed'} ${!isMobile ? focusClass : ''}`}>
                <Document className="pdf-document"
                  file="/The-Clarion-January-Newsletter.pdf"
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {numPages && (
                    <div className='flipbook-div' style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
                      <HTMLFlipBook
                        key={isMobile ? 'mobile' : 'desktop'}
                        className="html-flipbook"
                        // width={isMobile ? 375 : 750}
                        // height={isMobile ? 670 : 750}
                        // width={dimensions.width} 
                        // height={dimensions.height}
                        size={isMobile ? "stretch" : "stretch"} // Stretch helps fill mobile width
                        startPage={0}
                        // usePortrait={isMobile ? true : true} // This is the key for single-page mobile view, change fore desktop
                        usePortrait={true} // This is the key for single-page mobile view, change fore desktop
                        onFlip={onFlip} // Listen for the page turn
                        showCover={true}
                        ref={book}
                        // clickEventForward={!isMobile}
                        // useMouseEvents={!isMobile}
                        // swipeDistance={isMobile ? 0 : 30}
                        // disableFlipByClick={isMobile}
                        // minWidth={ isMobile ? 300 : 550}
                        // maxWidth={2000}
                        // minHeight={isMobile ? 400 : 1200}
                        // maxHeight={2000}
                        // minWidth={minWidth}
                        // maxWidth={maxWidth}
                        // minHeight={minHeight}
                        // maxHeight={maxHeight}
                      >
                        {Array.from(new Array(numPages), (_, index) => (
                          <div 
                            key={index} 
                            className='page-wrapper' 
                            style={{ backgroundColor: "white" }} 
                            onPointerDown={(e) => {
                                if (isMobile) {
                                  // ONLY block events on mobile to stop the 'tap-to-flip'
                                  e.stopPropagation(); 
                                }
                                // On Desktop, we do nothing, letting the event bubble up to the book
                              }}
                              onClick={(e) => {
                                if (isMobile) {
                                  e.stopPropagation();
                                } else {
                                  // On Desktop, run your logic but DON'T stop propagation
                                  handlePageClick(index);
                                }
                              }}
                          >
                            <Page
                              pageNumber={index + 1}
                              width={dimensions.width}
                              height={dimensions.height}
                              renderTextLayer={false}
                              renderAnnotationLayer={false}
                              onRenderSuccess={index < 2 ? onPageRenderSuccess : null}
                            ></Page>
                          </div>
                        ))}
                      </HTMLFlipBook>
                    </div>
                  )}
                </Document>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Publication;

// make this dynamic
// import { Document, Page } from 'react-pdf';
// import HTMLFlipBook from 'react-pageflip';

// function MyMagazine() {
//   const [numPages, setNumPages] = React.useState(0);

//   // This runs once the PDF is successfully loaded
//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//   };

//   return (
//     <Document 
//       file="my-cool-magazine.pdf" 
//       onLoadSuccess={onDocumentLoadSuccess}
//     >
//       <HTMLFlipBook width={500} height={700}>
//         {/* We loop through the total number of pages and render each one */}
//         {Array.from(new Array(numPages), (el, index) => (
//           <div key={`page_${index + 1}`} className="page-wrapper">
//             <Page pageNumber={index + 1} width={500} />
//           </div>
//         ))}
//       </HTMLFlipBook>
//     </Document>
//   );
// }